import React from "react"

export default function Email({ size, style }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="100" width="100" viewBox="0 0 128 128" style={{ width: size, height: size, ...style }} aria-hidden="true">
      <path
        stroke="currentColor"
        fill="currentColor"
        d="M108 16H20C8.973 16 0 24.973 0 36v56c0 11.027 8.973 20 20 20h88c11.027 0 20-8.973 20-20V36c0-11.027-8.973-20-20-20zm12 76c0 6.617-5.383 12-12 12H20c-6.617 0-12-5.383-12-12V36c0-6.617 5.383-12 12-12h88c6.617 0 12 5.383 12 12zm-9.172-53.172L85.656 64l25.172 25.172a3.997 3.997 0 0 1 0 5.656C110.047 95.609 109.023 96 108 96s-2.047-.391-2.828-1.172L80 69.656 66.828 82.828C66.047 83.609 65.023 84 64 84s-2.047-.391-2.828-1.172L48 69.656 22.828 94.828C22.047 95.609 21.023 96 20 96s-2.047-.391-2.828-1.172a3.997 3.997 0 0 1 0-5.656L42.344 64 17.172 38.828c-1.563-1.563-1.563-4.094 0-5.656s4.094-1.563 5.656 0L64 74.344l41.172-41.172c1.563-1.563 4.094-1.563 5.656 0s1.563 4.094 0 5.656z" />
    </svg>
  )
}
